module.exports = __webpack_public_path__ + "static/media/3 12 Tulleord Brillter er feil-norming.ee00489e.mp3";